module.exports = __webpack_public_path__ + "static/img/10.9bd7980.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/zh/10.png
// module id = 1Gls
// module chunks = 0